import * as React from 'react';
import {
    DateField,
    EditButton,
    ImageField,
    Show,
    SimpleShowLayout,
    TextField,
    TopToolbar,
    useShowContext
} from 'react-admin';
import {Typography} from "@mui/material";

const BlogShowActions = () => (
    <TopToolbar>
        <EditButton/>
    </TopToolbar>
);

const BlogShowLayout = () => {
    const {
        error,
        isLoading,
        record,
    } = useShowContext();

    if (isLoading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div>Error!</div>;
    }
    return (
        <SimpleShowLayout>
            <TextField source="id" label={"ID"}/>
            <TextField source="title" label={"Cím"}/>
            <TextField source="lead" label={"Alcím"}/>
            <Typography sx={{fontSize: '0.75em', color: '#B2BAC2', marginBottom: '0.2em'}}>Tartalom</Typography>
            <div dangerouslySetInnerHTML={{__html: record.content}}/>
            <DateField source="createdAt" locales={['hu-HU']} label={"Létrehozva"} showTime/>
            <ImageField source={"thumbnail"} label={"Index kép"}/>
        </SimpleShowLayout>
    );
};


export const BlogShow = () => {
    return <Show title={'Blog bejegyzés'} actions={<BlogShowActions/>}>
        <BlogShowLayout/>
    </Show>;
};
